var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SvgShoppingBasketCheck = function (props) { return (_jsxs("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 18", width: "1em", height: "1em" }, props, { children: [_jsx("path", { stroke: "currentColor", strokeMiterlimit: 10, strokeWidth: 1.25, d: "M13.626 14.817a.5.5 0 0 1-.483.37H4.857a.5.5 0 0 1-.483-.37l-2.143-8a.5.5 0 0 1 .483-.63h12.572a.5.5 0 0 1 .483.63z" }), _jsx("path", { stroke: "currentColor", strokeMiterlimit: 10, strokeWidth: 1.25, d: "M4.5 6.188 8.646 2.04a.5.5 0 0 1 .708 0L13.5 6.188m-7.312 4.5 1.521 1.52a.5.5 0 0 0 .707 0l3.771-3.77" })] }))); };
export default SvgShoppingBasketCheck;
